<template>
  <header class="header">
    <div class="container">
      <a href="https://www.cultureelerfgoed.nl/">
        <img
          src="@/assets/images/logo.svg"
          draggable="false"
          alt="Rijksdienst voor het Cultureel Erfgoed"
          class="logo"
          width="303"
          height="120"      
        />
      </a>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
  .header {
    position: relative;
    height: $header-height;
    background-color: white;
    overflow: hidden;

    @media (max-width: 479px) {
      height: $header-height-mobile;
    }
  }
  .container {

  }
  .logo {
    position: absolute;
    left: calc(50% - 24px); // 24px is half of the blue bar in the logo
    top: 0;

    @media (max-width: 479px) {
      width: 160px;
      left: calc(50% - 13px);
      height: 64.11px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue